import { Typography } from '@altify/components';
import { useNavigate } from '@tanstack/react-router';
import imgChevron from 'app/_authenticated/trade/recurring-buy/assets/chevron-right.svg';
import RecurringBuyImage from 'app/_authenticated/trade/recurring-buy/assets/recurring-buy-create.svg';

export function CreateRecurringBuyCard({
  heading,
  subHeading,
}: {
  heading: string;
  subHeading: string;
}) {
  const navigate = useNavigate();
  return (
    <>
      <div
        className="bg-[#1E2741] rounded-md shrink-0 hover:cursor-pointer mb-2 hidden lg:flex"
        onClick={() => navigate({ to: '/trade/recurring-buy' })}>
        <div className="flex flex-row items-center py-3 px-4 justify-between w-full">
          <div className="flex flex-row items-center">
            <img src={RecurringBuyImage} />
            <div className="ml-4 flex flex-col">
              <Typography>{heading}</Typography>
              <Typography className="text-gray-100" size="small">
                {subHeading}
              </Typography>
            </div>
          </div>
          <div className="flex flex-row items-center">
            <img
              className="ml-6 rounded-xl h-8 w-8"
              src={imgChevron}
            />
          </div>
        </div>
      </div>
    </>
  );
}
